import * as THREE from 'three'

/**
 * Çeşme — tools/blender/fountain.py (havuz + iki çanak + su perdeleri, sabit).
 * Üstüne akan damlalar: tek InstancedMesh (tek çizim), her akış bir kavis boyunca döngüyle iner.
 * Akış noktaları fountain.py çıktısından (yerel, z yukarı; açı +X'ten saat yönü tersine).
 */
const STREAMS = [
    // [açılar (derece), çıkış yarıçapı, çıkış z, iniş yarıçapı, iniş z, yukarı atış, damla sayısı]
    [[0, 90, 180, 270], 0.93, 1.5, 1.42, 0.45, 0.12, 7],     // 1. çanak → havuz
    [[45, 135, 225, 315], 0.485, 2.4, 0.72, 1.455, 0.1, 6],  // 2. çanak → 1. çanak
    [[0, 90, 180, 270], 0.1, 2.56, 0.26, 2.36, 0.22, 4]      // tepelik fıskiyesi → 2. çanak
]
const SPEED = 0.55 // akış döngüsü / sn

export default class FountainSection
{
    constructor(_options)
    {
        // Options
        this.time = _options.time
        this.resources = _options.resources
        this.objects = _options.objects
        this.x = _options.x
        this.y = _options.y

        // Set up
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.setStatic()
        this.setDroplets()
    }

    setStatic()
    {
        this.objects.add({
            base: this.resources.items.fountainStaticBase.scene,
            collision: this.resources.items.fountainStaticCollision.scene,
            floorShadowTexture: this.resources.items.fountainStaticFloorShadowTexture,
            offset: new THREE.Vector3(this.x, this.y, 0),
            mass: 0
        })
    }

    setDroplets()
    {
        // Her damla: akış + faz; açıya küçük sapma → perde gibi dağılır
        this.drops = []
        for(const [_angles, _r0, _z0, _r1, _z1, _kick, _count] of STREAMS)
        {
            for(const _angle of _angles)
            {
                for(let i = 0; i < _count; i++)
                {
                    const spread = ((i * 7) % 5 - 2) * 0.05
                    this.drops.push({
                        angle: THREE.MathUtils.degToRad(_angle) + spread,
                        r0: _r0, z0: _z0, r1: _r1, z1: _z1, kick: _kick,
                        phase: i / _count,
                        size: 0.055 + ((i * 3) % 4) * 0.012
                    })
                }
            }
        }

        const geometry = new THREE.IcosahedronGeometry(1, 0)
        const material = new THREE.MeshBasicMaterial({ color: 0xf2fdff, transparent: true, opacity: 0.9 }) // buz renkli perdelerden ayrışsın
        this.droplets = new THREE.InstancedMesh(geometry, material, this.drops.length)
        this.droplets.frustumCulled = false
        this.container.add(this.droplets)

        const matrix = new THREE.Matrix4()
        const position = new THREE.Vector3()
        const quaternion = new THREE.Quaternion()
        const scale = new THREE.Vector3()

        this.time.on('tick', () =>
        {
            const elapsed = this.time.elapsed * 0.001 * SPEED
            this.drops.forEach((_drop, _index) =>
            {
                const t = (elapsed + _drop.phase) % 1
                const r = _drop.r0 + (_drop.r1 - _drop.r0) * t
                // Kavis: önce hafif yukarı, sonra iniş noktasına düşüş (t=0 çıkış, t=1 iniş)
                const z = _drop.z0 + _drop.kick * t - (_drop.kick + _drop.z0 - _drop.z1) * t * t
                position.set(this.x + Math.cos(_drop.angle) * r, this.y + Math.sin(_drop.angle) * r, z)
                // İnişe yaklaşınca küçül (suya karışır)
                scale.setScalar(_drop.size * Math.min(1, (1 - t) * 6))
                matrix.compose(position, quaternion, scale)
                this.droplets.setMatrixAt(_index, matrix)
            })
            this.droplets.instanceMatrix.needsUpdate = true
        })
    }
}
